import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { WidgetsModule } from '@shared/components/widgets/widgets.module';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';
import { AsyncPipe } from '@angular/common';
import { PanelHeaderComponent } from '../@shared/panel-header/panel-header.component';
import { PanelContainerComponent } from '../@shared/panel-container/panel-container.component';
import { JupiterPanelComponent } from '../jupiter-panel.component';

@Component({
  selector: 'jupiter-panel-comments',
  templateUrl: './comments.component.html',
  standalone: true,
  imports: [
    MatLegacyFormFieldModule,
    MatLegacyMenuModule,
    MatLegacyInputModule,
    WidgetsModule,
    MatIconModule,
    MatLegacyTooltipModule,
    ReactiveFormsModule,
    AsyncPipe,
    PanelContainerComponent,
    PanelHeaderComponent,
  ],
  styleUrls: ['./comments.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CommentPanelComponent extends JupiterPanelComponent<any> implements OnInit {}
